import dayjs from 'dayjs';

export class CollectionModel {
  id?: string;
  recipient: string;
  title: string;
  editorText: string;
  text: string;
  amount: number;
  schedule: string;
  dayOfTheMonth?: number;
  dayOfTheWeek?: number;
  status: string;
  utcOffset: number;
  endDate: string;
  tested: boolean;
  clientDateTime: string;
  createDateTime: string;
  sendCopy: boolean;
  paymentMethods: PaymentMethod[];
  daysUntilNext: number;
  onBehalfOf?: string;
  verify: boolean;
}

export class PaymentMethod {
  service: string;
  serviceUser: string;
  nameOfUser: string;
  constructor(service: string) {
    this.service = service;
    this.serviceUser = "";
    this.nameOfUser = "";
  }
}

export class CollectionTotal {
  total: number;
  service: string;
}

export class CollectionReport {
  collectionTotals: CollectionTotal[];
  notificationsTotal: number;
  notificationsYearToDate: number;
  notificationsLastYear: number;
  notificationLastSent: string;
  notificationNext: string;
  lastUpdatedDate: string;
  activeCollectionCount: number;
}

export const emptyCollection = (): CollectionModel => {  
  let now = dayjs();
  return {
    recipient: "",
    title: "",
    editorText: "",
    text: "",
    amount: 0,
    utcOffset: now.utcOffset(),
    schedule: "monthly",
    dayOfTheMonth: 1,
    status: "active",
    endDate: now.add(1, 'year').add(now.utcOffset(), 'minutes').toISOString(),
    clientDateTime: now.toISOString(),
    createDateTime: now.toISOString(),
    sendCopy: false,
    paymentMethods: [],
    tested: false,
    daysUntilNext: 365,
    verify: true
  }
}